import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import axios from "axios";

import { addEntities } from "../../entities";
import {
  QUERY_FUNDING_REQUEST_REQUEST,
  QUERY_FUNDING_REQUEST_SUCCESS,
  QUERY_FUNDING_REQUEST_FAILURE
} from "../types";

const handleResponse = (
  response,
  dispatch,
  paymentProfileRelationship,
  id,
  limit,
  ordering,
  filters
) => {
  const data = normalize(response.results, [paymentProfileRelationship]);
  dispatch(addEntities(data.entities));
  dispatch(
    createAction(QUERY_FUNDING_REQUEST_SUCCESS)({
      id,
      items: data.result,
      count: response.count,
      next: response.next,
      previous: response.previous,
      ordering,
      limit,
      filters
    })
  );
  return response;
};

const debounced = debounce(
  async (dispatch, schema, api, id, limit, ordering, filters) => {
    dispatch(
      createAction(QUERY_FUNDING_REQUEST_REQUEST)({
        limit,
        filters,
        ordering
      })
    );
    const response = await api.groups.getFundingRequests(
      id,
      limit,
      ordering,
      filters
    );
    handleResponse(
      response,
      dispatch,
      schema.fundingRequest,
      id,
      limit,
      ordering,
      filters
    );
  },
  1000,
  { trailing: true }
);

export const next = (id, link, limit, ordering, filters) => async (
  dispatch,
  getState,
  { schema }
) => {
  try {
    dispatch(
      createAction(QUERY_FUNDING_REQUEST_REQUEST)({
        id,
        limit,
        ordering,
        filters
      })
    );

    const response = await axios.get(link);
    handleResponse(
      response.data,
      dispatch,
      schema.fundingRequest,
      id,
      limit,
      ordering,
      filters
    );
  } catch (err) {
    dispatch(createAction(QUERY_FUNDING_REQUEST_FAILURE)(err));
    throw err;
  }
};

const queryRelationships = (...args) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, ...args);
  } catch (err) {
    dispatch(createAction(QUERY_FUNDING_REQUEST_FAILURE)(err));
    throw err;
  }
};

export default queryRelationships;
